
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, User } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ProfileHeaderProps {
  title: string;
  description: string;
  showBackButton?: boolean;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ 
  title, 
  description, 
  showBackButton = false 
}) => {
  return (
    <div className="mb-8 animate-fade-in relative">
      {/* Subtle background effect */}
      <div className="absolute -top-10 -left-10 w-48 h-48 bg-gradient-radial from-neon-purple/10 to-transparent rounded-full blur-2xl -z-10" />
      
      <div className="flex items-center gap-2">
        {showBackButton && (
          <Button variant="glass" size="sm" asChild className="mr-2 hover:border-neon-blue/30 hover:text-neon-blue transition-all duration-300">
            <Link to="/">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back
            </Link>
          </Button>
        )}
        <h1 className="text-3xl md:text-4xl font-bold flex items-center gap-2 relative">
          {/* Decorative element */}
          <div className="absolute -left-3 top-1/2 transform -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-neon-blue via-neon-purple to-neon-pink rounded-full opacity-70" />
          
          <div className="h-10 w-10 rounded-full flex items-center justify-center bg-gradient-to-br from-neon-purple/20 to-black/50 border border-white/10">
            <User className="h-5 w-5 text-white" />
          </div>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300">{title}</span>
        </h1>
      </div>
      <p className="text-muted-foreground ml-12 mt-2">{description}</p>
      
      {/* Subtle divider */}
      <div className="mt-6 h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </div>
  );
};

export default ProfileHeader;
